import label from "@/lang/StaticLabels.js";

// PCRM Router  -----------------------------------------------
let routeItems = {
  path: "PMKT",
  name: "PMKT",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PMKTDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PMKTDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.pmkt,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/Dashboard"),
    },
    // Base Information  -----------------------------------------------
    {
      path: "campaignType",
      name: "PMKTCampaignType",
      meta: {
        label: label.page.campaignType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/base/campaignType"),
    },
    {
      path: "leadType",
      name: "PMKTLeadType",
      meta: {
        label: label.page.leadType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/base/leadType"),
    },
    {
      path: "leadProperty",
      name: "PMKTLeadProperty",
      meta: {
        label: label.page.leadProperty,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/base/leadProperty"),
    },
    {
      path: "leadSource",
      name: "PMKTLeadSource",
      meta: {
        label: label.page.leadSource,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/base/leadSource"),
    },
    {
      path: "leadEvaluationQuestion",
      name: "PMKTLeadEvaluationQuestion",
      meta: {
        label: label.page.leadEvaluationQuestion,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pmkt/base/leadEvaluationQuestion"),
    },
    {
      path: "chancePriority",
      name: "PMKTChancePriority",
      meta: {
        label: label.page.chancePriority,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/base/chancePriority"),
    },
    {
      path: "failedSaleReason",
      name: "PMKTFailedSaleReason",
      meta: {
        label: label.page.failedSaleReason,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/base/failedSaleReason"),
    },
    {
      path: "strengthWeakness",
      name: "PMKTStrengthWeakness",
      meta: {
        label: label.page.strengthWeakness,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/base/strengthWeakness"),
    },
    {
      path: "saleRegion",
      name: "PMKTSaleRegion",
      meta: {
        label: label.page.saleRegion,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/base/saleRegion"),
    },
    {
      path: "saleTeam",
      name: "PMKTSaleTeam",
      meta: {
        label: label.page.saleTeam,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/base/saleTeam"),
    },
    // Operation -----------------------------------------------
    {
      path: "campaign",
      name: "PMKTCampaign",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "campaign/list",
      children: [
        {
          path: "list",
          name: "PMKTCampaignList",
          component: () => import("@/views/modules/pmkt/operation/campaign"),
          meta: {
            label: label.page.campaignManagement,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PMKTAddCampaign",
          component: () =>
            import("@/views/modules/pmkt/operation/campaign/Add"),
          meta: {
            label: label.page.addCampaign,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PMKTEditCampaign",
          component: () =>
            import("@/views/modules/pmkt/operation/campaign/Edit"),
          meta: {
            label: label.page.editCampaign,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "lead",
      name: "PMKTLead",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "lead/list",
      children: [
        {
          path: "list",
          name: "PMKTLeadList",
          component: () => import("@/views/modules/pmkt/operation/lead"),
          meta: {
            label: label.page.lead,
            requiresAuth: true,
          },
        },
        {
          path: "saleTeamAssignment",
          name: "PMKTLeadSaleTeamAssignment",
          component: () => import("@/views/modules/pmkt/operation/lead"),
          props: { listType: "saleTeamAssignment" },
          meta: {
            label: label.page.saleTeamAssignment,
            requiresAuth: true,
          },
        },
        {
          path: "evaluationCartable",
          name: "PMKTLeadEvaluationCartable",
          component: () => import("@/views/modules/pmkt/operation/lead"),
          props: { listType: "evaluationCartable" },
          meta: {
            label: label.page.evaluationCartable,
            requiresAuth: true,
          },
        },
        {
          // تعریف سرنخ: فقط فرم تب‌دار ثبت سرنخ، بدون لیست و مدال
          path: "add",
          name: "PMKTAddLead",
          component: () =>
            import("@/views/modules/pmkt/operation/lead/AddLead"),
          meta: {
            label: label.page.addLead,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PMKTEditLead",
          component: () =>
            import("@/views/modules/pmkt/operation/lead/AddEdit"),
          meta: {
            label: label.page.editLead,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "chance",
      name: "PMKTChanceList",
      meta: {
        label: label.page.chance,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/operation/chance"),
    },
    {
      path: "salesPipeline",
      name: "PMKTSalesPipeline",
      meta: {
        label: label.page.salesPipeline,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/operation/salesPipeline"),
    },
    {
      path: "followUpCartable",
      name: "PMKTFollowUpCartable",
      meta: {
        label: label.page.myFollowUpCartable,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pmkt/operation/followUpCartable"),
    },
    {
      path: "activityCalendar",
      name: "PMKTActivityCalendar",
      meta: {
        label: label.page.activitiesAndCalendar,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pmkt/operation/activityCalendar"),
    },
    {
      path: "proposalContract",
      name: "PMKTProposalContract",
      meta: {
        label: label.page.proposalsAndContracts,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pmkt/operation/proposalContract"),
    },
    // Reports -----------------------------------------------
    {
      path: "reports/saleFunnel",
      name: "PMKTSaleFunnelReport",
      meta: {
        label: label.page.saleFunnelReport,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/reports/saleFunnel"),
    },
    {
      path: "reports/leadChanceConversion",
      name: "PMKTLeadChanceConversionReport",
      meta: {
        label: label.page.leadChanceConversionReport,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/pmkt/reports/leadChanceConversion"),
    },
    {
      path: "competitor",
      name: "PMKTCompetitorList",
      meta: {
        label: label.page.competitor,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/pmkt/operation/competitor"),
    },
  ],
};

export default routeItems;
